import React from 'react'
import Tittle from '../Components/Tittle'
import translate from "../Translation/i18nProvider/translate";
import SkillsSection from '../Components/SkillsSection';

function SkillsPage() {
    return (
        <div>
            <Tittle title={translate('about_title_Skills')} />
            <div className="skillsContainer">
                <SkillsSection skill={'Javascript'} progress={'55%'} width={'55%'} />
                <SkillsSection skill={'Typescript'} progress={'10%'} width={'10%'} />
                <SkillsSection skill={'React Js'} progress={'65%'} width={'65%'} />
                <SkillsSection skill={'Node Js'} progress={'30%'} width={'30%'} />
                <SkillsSection skill={'Web Design'} progress={'40%'} width={'40%'} />
                <SkillsSection skill={'UI/Ux Design'} progress={'30%'} width={'30%'} />
            </div> 
        </div>
    )
}

export default SkillsPage
